window.PesquisarAtendimentoClienteController = ControllerBase.extend({
    name: 'PesquisarAtendimentoClienteController',
    framework: 'knockout',
    region: '#pesquisar-atendimentos-clientes-region',
    tamanhoPagina: 10,
    ajax: function() {
        return {
            url: '/AtendimentoCliente/_Pesquisar',
            type: 'get'
        }
    },

    newModel: function () {

        return {
            CodigoCliente: null,
            NomeCliente: null,
            CodigoVendedor: null,
            DataFinal: null,
            DataFinalProximoContato: null,
            DataInicial: null,
            DataInicialProximoContato: null,
            Ordenacao: null,
            SomenteNaoLidos: false,
            permitidoAlterarCliente: true
        };

    },
    initialize: function () {
        this.setModel(this.newModel());
    },
    antesBinding: function () {

        this.addActionButton({
            text: "Limpar",
            'class': "icone-excluir separador",
            click: $.proxy(this.limpar, this)
        }, true);

        this.appendToModel({ name: 'vendedores', value: [] });
        this.appendToModel({ name: 'atendimentos', value: [] });
        this.select2Vendedores = {
            ajax: {
                url: '/Vendedor/ListarPorNome',
                type: 'post',
                data: function(params) {
                    return {
                        nome: params.term
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (i) {
                            return { id: i.Codigo, text: i.Nome };
                        })
                    };
                }
            },
            minimumInputLength: 1
        };

        var limparCallback = $.proxy(this.limparResultado, this);
        this.model.CodigoCliente.subscribe(limparCallback);
        this.model.DataFinal.subscribe(limparCallback);
        this.model.DataFinalProximoContato.subscribe(limparCallback);
        this.model.DataInicial.subscribe(limparCallback);
        this.model.DataInicialProximoContato.subscribe(limparCallback);
        this.model.Ordenacao.subscribe(limparCallback);
        this.model.SomenteNaoLidos.subscribe(limparCallback);

        if (this.cliente) {
            this.model.CodigoCliente(this.cliente.get('Codigo'));
            this.model.NomeCliente(this.cliente.get('Nome'));
            this.model.permitidoAlterarCliente(false);
        }

        if (this.vendedor) {
            this.model.CodigoVendedor(this.vendedor.Codigo);
            $('#form-atendimento-clientes select[name=Vendedores]').append($('<option>',
            {
                value: this.vendedor.Codigo,
                text: this.vendedor.Nome
            }));
        }
        

    },
    limpar: function () {
        $('#form-atendimento-clientes select[name=Vendedores]').empty();
        if (!this.cliente) {
            this.model.CodigoCliente(undefined);
            this.model.NomeCliente(undefined);
        }
        this.model.DataFinal(undefined);
        this.model.DataFinalProximoContato(undefined);
        this.model.DataInicial(undefined);
        this.model.DataInicialProximoContato(undefined);
        this.model.Ordenacao(1);
        this.model.SomenteNaoLidos(false);
        this.limparResultado();
    },
    limparResultado: function() {
        this.model.atendimentos.removeAll();
        this.atualizarPaginador();
    },
    pesquisarCliente: function () {
        this.pesquisarClientesController = this.showView({
            region: {
                name: "pesquisarClientesAtendimentoClientesRegion",
                selector: "#pesquisar-clientes-atendimento-clientes-region"
            },
            controller: {
                type: PesquisarClientesController,
                args: {
                    clienteSelecionadoCallbackView: $.proxy(this.clienteSelecionado, this)
                }
            }
        });
    },
    clienteSelecionado: function (cliente) {
        if (!cliente) {
            return;
        }
        this.model.CodigoCliente(cliente.get("Codigo"));
        this.model.NomeCliente(cliente.get("Nome"));
        this.pesquisarClientesController.hide();
        this.show();
    },
    removerCliente: function () {
        this.model.CodigoCliente(undefined);
        this.model.NomeCliente(undefined);
    },
    removerVendedor: function () {
        $('#form-atendimento-clientes select[name=Vendedores]').val(null);
        this.model.CodigoVendedor(undefined);
    },
    pesquisar: function (model, e, pagina) {

        if (!global.isFormValid("#form-atendimento-clientes")) {
            return;
        }

        var self = this;
        var filtros = this.toJS(this.model);
        filtros.NumeroPagina = pagina || 1;
        filtros.TamanhoPagina = this.tamanhoPagina;

        global.ajax({
            url: '/AtendimentoCliente/Listar',
            type: 'post',
            data: global.toJSONString({ filtros: filtros }),
            success: function (data) {
                
                if (!data || data.HasErrors) {
                    self.model.atendimentos.removeAll();
                    self.atualizarPaginador();
                    return;
                }
                var m = ko.mapping.fromJS(data.Entities);
                self.model.atendimentos(m());
                self.atualizarPaginador(data);
            }
        });

    },
    paginar: function (e) {
        this.pesquisar(null, null, e.page);
    },
    atualizarPaginador: function (data) {

        this.paginador = new Paginator({
            container: "#page-atendimento-clientes",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },
    definirLeitura: function (model) {
        var lido = !model.Lido();
        global.ajax({
            url: '/AtendimentoCliente/DefinirLeitura',
            type: 'post',
            data: {
                codigoAtendimento: model.Codigo(),
                lido: lido
            },
            success: function (data) {
                if (!data || data.HasErrors) {
                    return;
                }
                model.Lido(lido);
            }
        });
    },
    novo: function() {
        this.cadastrarAtendimentoClienteController = this.showView({
            region: {
                name: 'cadastrarAtendimentoClienteRegion',
                selector: '#cadastrar-atendimento-cliente-region'
            },
            controller: {
                type: CadastrarAtendimentoClienteController,
                args: {
                    salvarCallback: $.proxy(this.salvarCallback, this),
                    cliente: this.cliente,
                    vendedor: this.vendedor
                }
            }
        });
    },
    salvarCallback: function() {
        this.cadastrarAtendimentoClienteController.hide();
        this.show();
    }
});